import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { JwtService } from '../services/jwt.service';

export const authGuard: CanActivateFn = () => {
  const jwtService = inject(JwtService);
  const router = inject(Router);
  if (!jwtService.isLogged()) {
    router.navigateByUrl('/login');
    return false;
  }
  return true;
};
